import { FileDropbox } from "@/components/shared/media/FileDropbox";
import { UploadFile } from "@/components/shared/media/UploadFile";
import { Alert, AlertTitle, Stack } from "@mui/material";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

interface IProps {
    onFileChange?: (hasFile: boolean) => void;
}

/**
 * PreprocessForm component - File upload form for topic import
 */
export const PreprocessForm = ({ onFileChange }: IProps) => {
    const {
        watch,
        formState: { errors },
    } = useFormContext();

    const file = watch("file");

    useEffect(() => {
        onFileChange?.(!!file);
    }, [file, onFileChange]);

    return (
        <Stack width={"100%"} gap={1}>
            <FileDropbox
                name="file"
                accept={{
                    "application/vnd.ms-excel": [".xlsx"],
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                        [".xlsx"],
                }}
                description="Upload an Excel file (.xlsx) to import topics."
            />
            <UploadFile name="file" />
            {errors.file && (
                <Alert severity="error" sx={{ width: "100%" }}>
                    <AlertTitle>{errors.file.type as string}</AlertTitle>
                    {errors.file.message as string}
                </Alert>
            )}
        </Stack>
    );
};
